<template>
    <div class="card" style="margin-top: 10px">
        <p class="title">Entity Details</p>
        <div class="customChart" style="padding: 85px 50px;">
            <template v-for="(item, index) in data">
                <div v-if="item.total>0" class="elementHeight" :style="divWidth(item)" :key="index">
                    <div class="top">
                        <p>{{index+1 === data.length ? `Fund Size($${item.totalTillNow})` : `$${item.totalTillNow}` }}</p>
                    </div>
                    <div class="body" :style="customBodyStyle(item)">
                        <p>{{item.name}}</p>
                        <p>${{item.total}}</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: "custom-chart",
    props: ["data","total"],
    methods: {
        divWidth(item){
            return `width: ${(item.total/this.total)*100}%`
        },
        customBodyStyle(item){
            let backgroundColor = "#eee";
            switch(item.name){
                case "Commited":{
                    backgroundColor = "#78DE87";
                    break;
                }
                case "Sent":{
                    backgroundColor = "#E8AC4D";
                    break;
                }
                case "Signed":{
                    backgroundColor="#9BA7FF";
                    break;
                }
                case "Wired":{
                    backgroundColor="#EDCACA";
                    break;
                }
                case "Signed & Wired": {
                    backgroundColor = "#D5D5D5";
                    break;
                }
                case "Co-signed":{
                    backgroundColor = "#FFD490";
                    break;
                }
                default:{
                    backgroundColor = "#6bcf7a"
                    break;
                }
            }
            return `background: ${backgroundColor}`
        }
    }
}
</script>
<style lang="scss" scoped>
    .customChart{
        display: flex;
        width: 100%;
    }
    .top{
        border-right: 1px solid #000;
        height: 40px;
        position: relative;
        p{
            position: absolute;
            right: -10px;
            top: -20px;
            font-size: 12px;
        }
    }
    .body{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height:160px;
        overflow: hidden;
        p{
            font-size: 14px;
            color: #000;
            margin: 0;
            text-align: center;
        }
    }
    .elementHeight{
        height: 200px
    }
    .title{
        font-size: 16px;
        font-weight: 500;
        margin-left: 20px;
        margin-top: 20px;
    }
</style>